import moment from "moment";

const localeDateFormats: Record<string, string> = {
    en: "DD/MM/YYYY",
    de: "DD.MM.YYYY",
    fr: "DD/MM/YYYY",
    el: "DD/MM/YYYY",
};

export const getDateFormat = (locale: string): string => {
    return localeDateFormats[locale] || "DD/MM/YYYY";
};

export const getDateMaskAndPlaceholder = (locale: string) => {
    switch (locale) {
        case "en":
            return { mask: "##/##/####", placeholder: "mm/dd/yyyy" };
        case "de":
            return { mask: "##.##.####", placeholder: "dd.mm.yyyy" };
        case "fr":
        case "el":
            return { mask: "##/##/####", placeholder: "dd/mm/yyyy" };
        default:
            return { mask: "##/##/####", placeholder: "dd/mm/yyyy" };
    }
};

export const formatLocaleDate = (date: Date | string, locale: string): string => {
    if (!date) return "";
    return moment(date).format(getDateFormat(locale));
};

export const parseLocaleDate = (value: string, locale: string): Date | null => {
    if (!value) return null;
    const fmt = getDateFormat(locale);
    const m = moment(value, fmt, true); // strict parsing
    return m.isValid() ? m.toDate() : null;
};


export const format = (date)=>{

    if(Array.isArray(date)){
        return date.map((d)=> moment(d).format('YYYY-MM-DD'))

    }
    return moment(date).format('YYYY-MM-DD')
}

export const toDate = (date)=>{

    if(Array.isArray(date)){
        return date.map((d)=> moment(d).toDate())

    }
    return moment(date).toDate()
}


export const getNextSaturdays = (weeksFromToday = 0) => {
    let thisSaturday = moment(new Date());
    thisSaturday.add(weeksFromToday,'weeks');
    thisSaturday.isoWeekday()
    thisSaturday.day(6 + (moment(new Date()).day() >= 6 ? 7 : 0))

    const nextSaturday = moment(thisSaturday);
    nextSaturday.add(7,'days')
    return [
        thisSaturday.toDate(),
        nextSaturday.toDate()
    ];
}

export const computeDaysBetween = (dateFrom:Date, dateTo:Date, defaultDays:number=1)=>{

    if(!dateFrom || !dateTo){
        return defaultDays
    }

    const df = moment(dateFrom)
    const dt = moment(dateTo)
    const days = dt.diff(df,'days')
    return days
}

export const nextPeriods = (dateFrom:Date, dateTo:Date, numberOfPeriods:Number=1)=>{


    const df = moment(dateFrom)
    const dt = moment(dateTo)
    const days = dt.diff(df,'days')


    let ret = []
    let nextDt = dt.clone()

    for(let i =0; i< numberOfPeriods; i++){
        const pdt = nextDt.clone().add(days,'days')
        const p = {
            'dateFrom': nextDt.toDate(),
            'dateTo': pdt.toDate(),
        }
        nextDt = pdt.clone()
        ret.push(p)
    }

    return ret

}
export const previousPeriods = (dateFrom:Date, dateTo:Date, numberOfPeriods:Number=1)=>{

    const df = moment(dateFrom)
    const dt = moment(dateTo)
    const days = dt.diff(df,'days')

    let ret = []
    let prevDt = df.clone()

    for(let i =0; i< numberOfPeriods; i++){
        const pdf= prevDt.clone().add(-days,'days')
        const p = {
            'dateFrom': pdf.toDate(),
            'dateTo': prevDt.toDate()
        }
        prevDt = pdf.clone()
        ret.push(p)
    }

    return ret

}

// strict DMY parser and future-or-today check using moment
export const parseDMY = (value: string): Date | null => {
    if (!value) return null;
    const m = moment(value, 'DD/MM/YYYY', true); // strict parsing
    return m.isValid() ? m.toDate() : null;
};

export const isTodayOrFuture = (date: Date): boolean => {
    const d = moment(date).startOf('day');
    const today = moment().startOf('day');
    return d.isSameOrAfter(today, 'day');
};


// Convert a localized date to API format yyyy-MM-dd
export const toApiDate = (value: string, locale: string): string | null => {
    if (!value) return null;
    const parsed = parseLocaleDate(value, locale);
    return parsed ? moment(parsed).format("YYYY-MM-DD") : null;
};

// Convert an API date yyyy-MM-dd to localized format
export const fromApiDate = (value: string, locale: string): string | null => {
    if (!value) return null;
    return moment(value,'YYYY-MM-DD').format(getDateFormat(locale));
};